export default __webpack_public_path__ + "static/media/uin.8a6f9aeb.png";